
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const ClubRole = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  BOARD: 'BOARD',
  TREASURER: 'TREASURER',
  SECRETARY: 'SECRETARY',
  TRAINER: 'TRAINER',
  MEMBER: 'MEMBER',
  READONLY: 'READONLY'
} as const

export type ClubRole = (typeof ClubRole)[keyof typeof ClubRole]


export const ContactKind = {
  PERSON: 'PERSON',
  ORGANIZATION: 'ORGANIZATION'
} as const

export type ContactKind = (typeof ContactKind)[keyof typeof ContactKind]


export const Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  DIVERSE: 'DIVERSE',
  UNKNOWN: 'UNKNOWN'
} as const

export type Gender = (typeof Gender)[keyof typeof Gender]


export const Salutation = {
  HERR: 'HERR',
  FRAU: 'FRAU',
  DIVERS: 'DIVERS',
  KEINE: 'KEINE',
  FIRMA: 'FIRMA',
  HERR_UND_FRAU: 'HERR_UND_FRAU',
  FAMILIE: 'FAMILIE',
  ELTERN: 'ELTERN'
} as const

export type Salutation = (typeof Salutation)[keyof typeof Salutation]


export const LetterSalutation = {
  LIEBE: 'LIEBE',
  LIEBE_FORMELL: 'LIEBE_FORMELL',
  SEHR_GEEHRTE: 'SEHR_GEEHRTE',
  DAMEN_HERREN: 'DAMEN_HERREN'
} as const

export type LetterSalutation = (typeof LetterSalutation)[keyof typeof LetterSalutation]


export const MaritalStatus = {
  SINGLE: 'SINGLE',
  MARRIED: 'MARRIED',
  DIVORCED: 'DIVORCED',
  WIDOWED: 'WIDOWED'
} as const

export type MaritalStatus = (typeof MaritalStatus)[keyof typeof MaritalStatus]


export const ContactStatus = {
  ACTIVE: 'ACTIVE',
  PASSIVE: 'PASSIVE',
  HONORARY: 'HONORARY',
  PROSPECT: 'PROSPECT',
  FORMER: 'FORMER',
  DECEASED: 'DECEASED',
  CONTACT: 'CONTACT'
} as const

export type ContactStatus = (typeof ContactStatus)[keyof typeof ContactStatus]


export const CommunicationChannel = {
  EMAIL: 'EMAIL',
  POST: 'POST'
} as const

export type CommunicationChannel = (typeof CommunicationChannel)[keyof typeof CommunicationChannel]


export const GroupKind = {
  TEAM: 'TEAM',
  DEPARTMENT: 'DEPARTMENT',
  BOARD: 'BOARD',
  COMMITTEE: 'COMMITTEE',
  SPONSOR: 'SPONSOR',
  FAN: 'FAN',
  OTHER: 'OTHER'
} as const

export type GroupKind = (typeof GroupKind)[keyof typeof GroupKind]


export const CustomFieldEntity = {
  CONTACT: 'CONTACT',
  EVENT: 'EVENT',
  GROUP: 'GROUP'
} as const

export type CustomFieldEntity = (typeof CustomFieldEntity)[keyof typeof CustomFieldEntity]


export const CustomFieldType = {
  TEXT: 'TEXT',
  LONGTEXT: 'LONGTEXT',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
  SELECT: 'SELECT',
  MULTISELECT: 'MULTISELECT',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  URL: 'URL'
} as const

export type CustomFieldType = (typeof CustomFieldType)[keyof typeof CustomFieldType]


export const FeeInterval = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  HALF_YEARLY: 'HALF_YEARLY',
  YEARLY: 'YEARLY',
  ONCE: 'ONCE'
} as const

export type FeeInterval = (typeof FeeInterval)[keyof typeof FeeInterval]


export const PaymentMethod = {
  TRANSFER: 'TRANSFER',
  SEPA: 'SEPA',
  CASH: 'CASH',
  PAYPAL: 'PAYPAL',
  CARD: 'CARD',
  OTHER: 'OTHER'
} as const

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod]


export const MandateType = {
  CORE: 'CORE',
  B2B: 'B2B'
} as const

export type MandateType = (typeof MandateType)[keyof typeof MandateType]


export const SepaSequence = {
  FIRST: 'FIRST',
  RECURRING: 'RECURRING',
  FINAL: 'FINAL',
  ONE_OFF: 'ONE_OFF'
} as const

export type SepaSequence = (typeof SepaSequence)[keyof typeof SepaSequence]


export const ItemType = {
  DETAIL: 'DETAIL',
  LUMP_SUM: 'LUMP_SUM',
  BUNDLE: 'BUNDLE',
  SUBTOTAL: 'SUBTOTAL',
  HEADING: 'HEADING',
  DESCRIPTION: 'DESCRIPTION',
  SEPARATOR: 'SEPARATOR',
  PAGE_BREAK: 'PAGE_BREAK',
  VOLUNTARY: 'VOLUNTARY'
} as const

export type ItemType = (typeof ItemType)[keyof typeof ItemType]


export const BundleDisplay = {
  LINES: 'LINES',
  LIST: 'LIST',
  TOTAL: 'TOTAL'
} as const

export type BundleDisplay = (typeof BundleDisplay)[keyof typeof BundleDisplay]


export const TaxTreatment = {
  STANDARD: 'STANDARD',
  EXEMPT: 'EXEMPT',
  NOT_TAXABLE: 'NOT_TAXABLE',
  SMALL_BUSINESS: 'SMALL_BUSINESS'
} as const

export type TaxTreatment = (typeof TaxTreatment)[keyof typeof TaxTreatment]


export const MandateStatus = {
  ACTIVE: 'ACTIVE',
  REVOKED: 'REVOKED',
  EXPIRED: 'EXPIRED'
} as const

export type MandateStatus = (typeof MandateStatus)[keyof typeof MandateStatus]


export const InvoiceStatus = {
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  PAID: 'PAID',
  OVERDUE: 'OVERDUE',
  CANCELLED: 'CANCELLED'
} as const

export type InvoiceStatus = (typeof InvoiceStatus)[keyof typeof InvoiceStatus]


export const InvoiceKind = {
  FEE: 'FEE',
  GENERAL: 'GENERAL',
  CANCELLATION: 'CANCELLATION',
  CREDIT_NOTE: 'CREDIT_NOTE'
} as const

export type InvoiceKind = (typeof InvoiceKind)[keyof typeof InvoiceKind]


export const BillingRunStatus = {
  DRAFT: 'DRAFT',
  CREATED: 'CREATED',
  SENT: 'SENT',
  EXPORTED: 'EXPORTED',
  CLOSED: 'CLOSED'
} as const

export type BillingRunStatus = (typeof BillingRunStatus)[keyof typeof BillingRunStatus]


export const BankAccountKind = {
  BANK: 'BANK',
  CASH: 'CASH',
  PAYPAL: 'PAYPAL'
} as const

export type BankAccountKind = (typeof BankAccountKind)[keyof typeof BankAccountKind]


export const BankTransactionStatus = {
  UNMATCHED: 'UNMATCHED',
  MATCHED: 'MATCHED',
  BOOKED: 'BOOKED',
  IGNORED: 'IGNORED'
} as const

export type BankTransactionStatus = (typeof BankTransactionStatus)[keyof typeof BankTransactionStatus]


export const LedgerAccountType = {
  INCOME: 'INCOME',
  EXPENSE: 'EXPENSE',
  ASSET: 'ASSET',
  LIABILITY: 'LIABILITY',
  EQUITY: 'EQUITY',
  CLOSING: 'CLOSING'
} as const

export type LedgerAccountType = (typeof LedgerAccountType)[keyof typeof LedgerAccountType]


export const TaxSphere = {
  IDEELL: 'IDEELL',
  VERMOEGEN: 'VERMOEGEN',
  ZWECKBETRIEB: 'ZWECKBETRIEB',
  WIRTSCHAFTLICH: 'WIRTSCHAFTLICH'
} as const

export type TaxSphere = (typeof TaxSphere)[keyof typeof TaxSphere]


export const AccountingMode = {
  CASHBOOK: 'CASHBOOK',
  EUR: 'EUR',
  DOUBLE_ENTRY: 'DOUBLE_ENTRY'
} as const

export type AccountingMode = (typeof AccountingMode)[keyof typeof AccountingMode]


export const RsvpStatus = {
  PENDING: 'PENDING',
  YES: 'YES',
  NO: 'NO',
  MAYBE: 'MAYBE'
} as const

export type RsvpStatus = (typeof RsvpStatus)[keyof typeof RsvpStatus]


export const CalendarFeedScope = {
  PUBLIC: 'PUBLIC',
  PERSONAL: 'PERSONAL',
  GROUP: 'GROUP'
} as const

export type CalendarFeedScope = (typeof CalendarFeedScope)[keyof typeof CalendarFeedScope]


export const MailingChannel = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  LETTER: 'LETTER'
} as const

export type MailingChannel = (typeof MailingChannel)[keyof typeof MailingChannel]


export const MailingStatus = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  SENDING: 'SENDING',
  SENT: 'SENT',
  FAILED: 'FAILED'
} as const

export type MailingStatus = (typeof MailingStatus)[keyof typeof MailingStatus]


export const DeliveryStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  OPENED: 'OPENED',
  BOUNCED: 'BOUNCED',
  FAILED: 'FAILED'
} as const

export type DeliveryStatus = (typeof DeliveryStatus)[keyof typeof DeliveryStatus]


export const TemplateKind = {
  EMAIL: 'EMAIL',
  LETTER: 'LETTER',
  SMS: 'SMS',
  INVOICE_TEXT: 'INVOICE_TEXT',
  DUNNING: 'DUNNING',
  DONATION_RECEIPT: 'DONATION_RECEIPT',
  WELCOME: 'WELCOME'
} as const

export type TemplateKind = (typeof TemplateKind)[keyof typeof TemplateKind]


export const Visibility = {
  PUBLIC: 'PUBLIC',
  MEMBERS: 'MEMBERS',
  GROUPS: 'GROUPS',
  BOARD: 'BOARD',
  PRIVATE: 'PRIVATE'
} as const

export type Visibility = (typeof Visibility)[keyof typeof Visibility]


export const DonationKind = {
  MONEY: 'MONEY',
  IN_KIND: 'IN_KIND',
  WAIVER: 'WAIVER'
} as const

export type DonationKind = (typeof DonationKind)[keyof typeof DonationKind]


export const PostAudience = {
  ALL: 'ALL',
  BOARD: 'BOARD',
  GROUP: 'GROUP'
} as const

export type PostAudience = (typeof PostAudience)[keyof typeof PostAudience]


export const TaskStatus = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE'
} as const

export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus]


export const FormKind = {
  MEMBERSHIP_APPLICATION: 'MEMBERSHIP_APPLICATION',
  EVENT_REGISTRATION: 'EVENT_REGISTRATION',
  CONTACT: 'CONTACT',
  CUSTOM: 'CUSTOM'
} as const

export type FormKind = (typeof FormKind)[keyof typeof FormKind]


export const SubmissionStatus = {
  NEW: 'NEW',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED'
} as const

export type SubmissionStatus = (typeof SubmissionStatus)[keyof typeof SubmissionStatus]


export const StorageDriver = {
  HETZNER_S3: 'HETZNER_S3',
  S3: 'S3',
  LOCAL: 'LOCAL'
} as const

export type StorageDriver = (typeof StorageDriver)[keyof typeof StorageDriver]


export const ImportSource = {
  CLUBDESK: 'CLUBDESK',
  CSV: 'CSV'
} as const

export type ImportSource = (typeof ImportSource)[keyof typeof ImportSource]


export const ImportStatus = {
  RUNNING: 'RUNNING',
  DONE: 'DONE',
  FAILED: 'FAILED'
} as const

export type ImportStatus = (typeof ImportStatus)[keyof typeof ImportStatus]


export const NonProfitBasis = {
  FREISTELLUNGSBESCHEID: 'FREISTELLUNGSBESCHEID',
  ANLAGE_KST_BESCHEID: 'ANLAGE_KST_BESCHEID',
  FESTSTELLUNG_60A: 'FESTSTELLUNG_60A'
} as const

export type NonProfitBasis = (typeof NonProfitBasis)[keyof typeof NonProfitBasis]


export const MandateSignature = {
  PAPER: 'PAPER',
  ONLINE: 'ONLINE'
} as const

export type MandateSignature = (typeof MandateSignature)[keyof typeof MandateSignature]


export const RetentionClass = {
  BUCHUNGSBELEG: 'BUCHUNGSBELEG',
  BUCH: 'BUCH',
  SONSTIGE: 'SONSTIGE',
  KEINE: 'KEINE'
} as const

export type RetentionClass = (typeof RetentionClass)[keyof typeof RetentionClass]


export const ConsentPurpose = {
  MEMBER_LIST: 'MEMBER_LIST',
  NEWSLETTER: 'NEWSLETTER',
  PHOTOS_INTERNAL: 'PHOTOS_INTERNAL',
  PHOTOS_PUBLIC: 'PHOTOS_PUBLIC',
  PRESS: 'PRESS',
  BIRTHDAY_PUBLISH: 'BIRTHDAY_PUBLISH',
  INTERNET: 'INTERNET'
} as const

export type ConsentPurpose = (typeof ConsentPurpose)[keyof typeof ConsentPurpose]


export const ConsentSource = {
  FORM: 'FORM',
  PORTAL: 'PORTAL',
  PAPER: 'PAPER',
  IMPORT: 'IMPORT'
} as const

export type ConsentSource = (typeof ConsentSource)[keyof typeof ConsentSource]


export const DataSubjectRequestKind = {
  AUSKUNFT: 'AUSKUNFT',
  BERICHTIGUNG: 'BERICHTIGUNG',
  LOESCHUNG: 'LOESCHUNG',
  EINSCHRAENKUNG: 'EINSCHRAENKUNG',
  WIDERSPRUCH: 'WIDERSPRUCH',
  UEBERTRAGUNG: 'UEBERTRAGUNG'
} as const

export type DataSubjectRequestKind = (typeof DataSubjectRequestKind)[keyof typeof DataSubjectRequestKind]


export const QualificationKind = {
  FUEHRUNGSZEUGNIS: 'FUEHRUNGSZEUGNIS',
  UEBUNGSLEITER_LIZENZ: 'UEBUNGSLEITER_LIZENZ',
  ERSTE_HILFE: 'ERSTE_HILFE',
  JULEICA: 'JULEICA',
  SONSTIGE: 'SONSTIGE'
} as const

export type QualificationKind = (typeof QualificationKind)[keyof typeof QualificationKind]


export const FederationKind = {
  LANDESSPORTBUND: 'LANDESSPORTBUND',
  FACHVERBAND: 'FACHVERBAND',
  SONSTIGER: 'SONSTIGER'
} as const

export type FederationKind = (typeof FederationKind)[keyof typeof FederationKind]


export const EInvoiceFormat = {
  PDF: 'PDF',
  ZUGFERD: 'ZUGFERD',
  XRECHNUNG: 'XRECHNUNG'
} as const

export type EInvoiceFormat = (typeof EInvoiceFormat)[keyof typeof EInvoiceFormat]


export const NumberReset = {
  NEVER: 'NEVER',
  YEARLY: 'YEARLY',
  MONTHLY: 'MONTHLY'
} as const

export type NumberReset = (typeof NumberReset)[keyof typeof NumberReset]


export const WebPageKind = {
  PAGE: 'PAGE',
  HOME: 'HOME',
  IMPRESSUM: 'IMPRESSUM',
  PRIVACY: 'PRIVACY'
} as const

export type WebPageKind = (typeof WebPageKind)[keyof typeof WebPageKind]


export const MailingPurpose = {
  INFO: 'INFO',
  NEWSLETTER: 'NEWSLETTER'
} as const

export type MailingPurpose = (typeof MailingPurpose)[keyof typeof MailingPurpose]


export const ContactRelation = {
  SELF: 'SELF',
  GUARDIAN: 'GUARDIAN',
  HOUSEHOLD: 'HOUSEHOLD'
} as const

export type ContactRelation = (typeof ContactRelation)[keyof typeof ContactRelation]
